// extracted by mini-css-extract-plugin
module.exports =  {"teamMemberList":"TeamMemberList-module_teamMemberList_fd7b2"};